import { Link } from "react-router-dom";
import { MediaBox } from "./MediaBox";
import { GRID } from "@/constants/testIds";

const ratioToCss = (ratio) => (ratio === "16:9" ? "16/9" : ratio === "9:16" ? "9/16" : "1/1");

export const GridView = ({ projects, searchString, linkBase = "/work" }) => {
  if (projects.length === 0) {
    return (
      <div data-testid="grid-empty-state" className="py-24 text-center font-mono text-sm uppercase tracking-widest text-[#888880]">
        No projects match these filters
      </div>
    );
  }
  return (
    <div data-testid={GRID.container} className="columns-1 sm:columns-2 lg:columns-3 gap-5 sm:gap-6 px-4 sm:px-8 py-8 sm:py-10 max-w-[1600px] mx-auto">
      {projects.map((p) => (
        <Link
          key={p.slug}
          to={`${linkBase}/${p.slug}`}
          state={{ fromSearch: searchString }}
          data-testid={GRID.card(p.slug)}
          className="group block mb-5 sm:mb-6 break-inside-avoid relative border border-[#2A2A2A] hover:border-[#CCFF00] transition-colors duration-300"
        >
          <div className="relative w-full" style={{ aspectRatio: ratioToCss(p.aspectRatio) }}>
            <MediaBox project={p} className="absolute inset-0" />
            {p.isDemo && (
              <span className="absolute top-2 right-2 font-mono text-[10px] tracking-widest uppercase bg-black/70 text-[#CCFF00] px-2 py-1 border border-[#CCFF00]/40">
                Demo
              </span>
            )}
          </div>
          <div className="p-3 flex items-center justify-between font-mono text-[10px] sm:text-xs tracking-widest uppercase text-[#F5F5F0] group-hover:text-[#CCFF00] transition-colors">
            <span className="truncate">{p.title}</span>
            <span className="text-[#888880] shrink-0 ml-2">{p.category}</span>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default GridView;
